export default __webpack_public_path__ + "static/media/project_img_6.eb00fdcf.jpeg";